import type { PropsWithChildren } from 'react';
import { createContext, useMemo } from 'react';

interface CurrentDocumentProviderProps {
  currentDocument: Document;
  currentWindow: Window;
}

export const CurrentDocumentContext = createContext<CurrentDocumentProviderProps>({
  currentWindow: window,
  currentDocument: document,
});

export const CurrentDocumentProvider = ({
  children,
  currentDocument,
  currentWindow,
}: PropsWithChildren<CurrentDocumentProviderProps>) => {
  const value = useMemo(
    () => ({
      currentDocument,
      currentWindow,
    }),
    [currentDocument, currentWindow]
  );
  return <CurrentDocumentContext.Provider value={value}>{children}</CurrentDocumentContext.Provider>;
};
